import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { getGroupedUseCases } from "@/data/geo-constants";
import { GeoUseCase } from "@/lib/types";

type GeoUseCaseSelectProps = {
  value: GeoUseCase | "";
  onChange: (value: GeoUseCase) => void;
};

export function GeoUseCaseSelect({ value, onChange }: GeoUseCaseSelectProps) {
  const groupedUseCases = getGroupedUseCases();

  return (
    <Select value={value} onValueChange={(v) => onChange(v as GeoUseCase)}>
      <SelectTrigger className="w-full bg-background/50 border-border/30">
        <SelectValue placeholder="Select use case..." />
      </SelectTrigger>
      <SelectContent className="bg-popover border-border z-50 max-h-[300px]">
        {Object.entries(groupedUseCases).map(([group, useCases]) => (
          <SelectGroup key={group}>
            <SelectLabel className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">
              {group}
            </SelectLabel>
            {useCases.map((useCase) => (
              <SelectItem key={useCase.value} value={useCase.value}>
                {useCase.label}
              </SelectItem>
            ))}
          </SelectGroup>
        ))}
      </SelectContent>
    </Select>
  );
}
